import { isNil } from 'ramda';
import {
  addFee,
  validFee,
} from '~admin/view/components/create-event/helper/event-profile-request/event-fee-details/add-fee.helper';
import { buildTaxList } from '~admin/view/components/create-event/helper/event-profile-request/event-fee-details/build-tax-list.helper';
import * as feeData from '~admin/view/components/create-event/helper/event-profile-request/event-fee-details/data/fees.data.json';
import { EventFeeFormData } from '~admin/view/components/details/event-details/event-fee-details.component';
import { MarketplaceFormData } from '~admin/view/components/details/marketplace-details/marketplace-details-fields.component';
import { FeeRequest } from '~client/model/admin/fee-request';
import { Currency } from '~client/model/currency';
import { MarketplaceType } from '~client/model/marketplace-type';

export const buildFeeList = (
  marketplaces: MarketplaceFormData[],
  feeFormData: EventFeeFormData,
  currency: Currency,
): FeeRequest[] => {
  if (isNil(feeFormData)) {
    return null;
  }

  const {
    flatFee,
    resaleFlatFee,
    profitFeeRate,
    sellerCreditCardFeeRate,
    taxType,
    creditCardFeeRate,
    includedInBase,
  } = feeFormData;

  const feeList: FeeRequest[] = [];
  const hasResale = Boolean(
    marketplaces.find(
      (marketplace: MarketplaceFormData) => marketplace.type === MarketplaceType.SECONDARY_EXCHANGE,
    ),
  );

  if (validFee(creditCardFeeRate)) {
    addFee(
      feeList,
      creditCardFeeRate,
      hasResale ? creditCardFeeRate : 0,
      false,
      feeData.processingFeeBuyer,
    );
  }

  if (hasResale && validFee(sellerCreditCardFeeRate)) {
    addFee(feeList, 0, sellerCreditCardFeeRate, false, feeData.processingFeeSeller);
  }

  if (validFee(flatFee) || (hasResale && validFee(resaleFlatFee))) {
    addFee(feeList, flatFee, hasResale ? resaleFlatFee : 0, includedInBase, feeData.yoopFeeBuyer);
  }

  if (hasResale) {
    if (validFee(resaleFlatFee)) {
      addFee(feeList, 0, resaleFlatFee, false, feeData.yoopFeeSeller);
    }

    if (validFee(profitFeeRate)) {
      addFee(feeList, 0, profitFeeRate, false, feeData.profitShare);
    }
  }

  buildTaxList(feeList, hasResale, taxType, currency);

  return feeList;
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-fee-details/build-fee-list.helper.ts